import React, { useMemo } from "react";
import { FormHelperText, SxProps, TextField } from "@mui/material";
import { Controller, FieldError, useFormContext, useWatch } from "react-hook-form";
import { FnComponents, I18n } from "utilities/utilities";
import { I18NextNs, RegularExpression, TypeComponent } from "enum/enum";

export const TextAreaItem = (props: ITextarea) => {
    //#region Variable
    const {
        id,
        name,
        label = "",
        placeholder,
        defaultValue = null,
        maxLength = 500,
        variant = "outlined",
        size = "small",
        margin = "normal",
        required = false,
        IsShowMessageError = true,
        disabled = false,
        fullWidth = true,
        startAdornment,
        endAdornment,
        row = 3,
        maxRows = 5,
        autoComplete = "off",
        IsShrink,
        IsDisplayLabel = true,
        pattern,
        IsShowTextCont = true,
    } = props;
    const {
        control,
        register,
        getValues,
    } = useFormContext();
    //#endregion

    const setObjValidate = (pattern, objvalidate) => {
        switch (pattern) {
            case "th":
                objvalidate["pattern"] = {
                    value: RegularExpression.Th,
                };
                break;
            case "en":
                objvalidate["pattern"] = {
                    value: RegularExpression.En,
                };
                break;
        }
        return objvalidate;
    }

    const rules = useMemo(() => {
        let objvalidate = {};
        if (!disabled) {
            objvalidate["required"] = {
                value: required,
                // message: `${I18n.SetText("required", I18NextNs.validation)} ${label}`,
            };
            objvalidate = setObjValidate(pattern, objvalidate);

        }
        return objvalidate;
    }, [disabled, required, pattern]);


    const genMessagePattern = (type) => {
        let sMessage = "";
        if (type === "text") {
            switch (pattern) {
                case "th":
                    sMessage = `${I18n.SetText("patternThai", I18NextNs.validation)}`;
                    break;
                case "en":
                    sMessage = `${I18n.SetText("patternEng", I18NextNs.validation)}`;
                    break;
            }
        }
        return sMessage;
    }

    const getMessageValidate = (error: FieldError) => {
        let sMessage = "";
        if (IsShowMessageError) {
            if (error) {
                switch (error.type) {
                    case "required":
                        sMessage = `${I18n.SetText("required", I18NextNs.validation)} ${label}`;
                        break;
                    case "pattern":
                        genMessagePattern("text");
                        break;
                    case "value":
                        sMessage = error.message;
                        break;
                }
            }
        }
        return sMessage;
    };

    const FieldName = useWatch({
        control,
        name: name,
    });

    const sCounter = `"${getValues(name) ? getValues(name).length : 0}/${props.maxLength}"`;
    const maxLengthText: SxProps = {
        "::after": {
            content: IsShowTextCont && props.maxLength
                ? sCounter : '""',
            position: "absolute",
            bottom: "5px",
            right: "10px",
            color: "#989898",
            fontSize: "10px",
        },
    };

    return (
        <Controller
            key={FnComponents.GetKey(TypeComponent.textArea, name)}
            name={name}
            control={control}
            rules={rules}
            shouldUnregister={true}
            defaultValue={defaultValue}
            render={({
                field: { onChange, value, ref },
                fieldState: { invalid, error },
            }) => {
                let helperText = getMessageValidate(error);
                let IsValid = invalid && !disabled;
                let InputLabelProps = {};
                let sValue = value ? value + "" : "";
                if (IsShrink || sValue.length > 0 || FieldName) {
                    InputLabelProps["shrink"] = true;
                }

                return (
                    <React.Fragment>
                        <TextField
                            {...props}
                            key={name}
                            inputRef={ref}
                            {...register(name)}
                            required={required}
                            id={FnComponents.GetId(TypeComponent.textArea, id, name)}
                            name={name}
                            label={FnComponents.GetLabel(label, IsDisplayLabel)}
                            placeholder={placeholder}
                            variant={variant}
                            type={"text"}
                            error={IsValid}
                            size={size}
                            fullWidth={fullWidth}
                            margin={margin}
                            multiline={true}
                            inputProps={{
                                maxLength: maxLength
                            }}
                            InputProps={{
                                startAdornment: startAdornment,
                                endAdornment: endAdornment,
                            }}
                            InputLabelProps={InputLabelProps}
                            // InputLabelProps={{
                            //     shrink: IsShrink || sValue.length > 0 || FieldName,
                            // }}
                            disabled={disabled}
                            onBlur={(e) => {
                                if (props.onBlur) {
                                    props.onBlur(e);
                                }
                            }}
                            onChange={(e) => {
                                if (props.onChange) {
                                    props.onChange(e);
                                }
                                onChange(e);
                            }}
                            onClick={(e) => {
                                if (props.onClick) {
                                    props.onClick(e);
                                }
                            }}
                            minRows={row}
                            maxRows={maxRows}
                            autoComplete={autoComplete}
                            style={props.style}
                            value={value}
                            onKeyDown={(e) => {
                                if (e.code === "Space") {
                                    e.stopPropagation()
                                }
                            }}
                            sx={[{ ...maxLengthText }, {
                                "& .MuiOutlinedInput-input": {
                                    padding: "9px 10px",
                                    marginTop: "5px"
                                },
                                marginBottom: '1px !important',                    
                            }]}
                        />
                        {(IsShowMessageError && invalid) && <FormHelperText>{helperText}</FormHelperText>}
                    </React.Fragment>
                )
            }}
        />
    );
};